import { Image } from "../../AppDataType";
import "./RoomThumbnail.css";

interface Props {
    selected: boolean;
    image: Image;
    onClick: () => void;
}

const RoomThumbnail: React.FC<Props> = ({ selected, image, onClick }) => {
    return (
        <div className={`room-carousel__thumbs__slide 
                        ${selected ? ' room-carousel__thumbs__slide--selected' : ''}
                        border-2 border-second-solid rounded-xl overflow-hidden`}>
            <button onClick={onClick}
                    type="button"
                    className="room-carousel__thumbs__slide__image h-full">
                <img src={image.src} 
                     alt={image.alt} 
                     className="size-full transition-transform duration-300 ease-out hover:scale-110"/>
            </button>
        </div>
    )
}

export default RoomThumbnail;
